module.exports = __webpack_public_path__ + "img/foam-tablet_b8d175fa24926d7df94362a84075869e.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/foam-tablet.jpg
// module id = 279
// module chunks = 0